module.exports = __webpack_public_path__ + "img/url.fa89befc.svg";